import axios from "axios";
import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import useGetEmail from "../hooks/GetEmail";
import { toast } from "react-toastify";

const UserNavbar = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const Location = useLocation();

  return (
    <div className="font-userFont mt-8   space-y-12 flex flex-col justify-center items-center">
      <h1 className="text-3xl text-center ">Saive</h1>
      <nav className="flex w-full justify-center">
        <ul className="flex w-auto mx-auto space-x-6 ">
          <li
            onClick={() => {
              navigate(id === undefined ? "/" : `/userDashboard/${id}`);
              // window.location.reload();
            }}
            className={`cursor-pointer ${
              Location.pathname === `/userDashboard/${id}` ||
              Location.pathname === "/"
                ? "underline font-bold"
                : ""
            }`}
          >
            Home
          </li>
          <li
            onClick={() => {
              navigate(`/account/${id}`);
            }}
            className={`cursor-pointer ${
              Location.pathname === `/account/${id}`
                ? "underline font-bold"
                : ""
            }`}
          >
            Account
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default UserNavbar;
